import { ReactNode } from 'react';
import { cn } from './lib';
import './Section.css';

type SectionProps = {
  title: string;
  meta?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  /* The body carries the standard inset (non-negotiable 6). `flush` removes
     it for content whose own cells provide the inset — dense tables, boards,
     row lists that draw their own padding. Tables and boards placed as the
     body's direct child are detected automatically; `flush` is the explicit
     escape for everything else, and the layout guard reads it. */
  flush?: boolean;
  /* The card's standing exit — "Open collections →", "Open sessions →".
     A footer, not a header action: the header says what the card is, the
     footer says where its whole story lives. */
  footer?: ReactNode;
  /* A stable handle for the capture harness and the tests. Cards are the
     unit a clip zooms into, so the card is where the handle belongs. */
  testId?: string;
};

export function Section({ title, meta, actions, children, className, flush, footer, testId }: SectionProps) {
  return (
    <section className={cn('mrd-section', className)} {...(testId ? { 'data-testid': testId } : {})}>
      <header className="mrd-section__header">
        <h2 className="mrd-section__title">{title}</h2>
        {meta != null && <span className="mrd-section__meta">{meta}</span>}
        {actions != null && <div className="mrd-section__actions">{actions}</div>}
      </header>
      <div className="mrd-section__body" {...(flush ? { 'data-flush': '' } : {})}>
        {children}
      </div>
      {footer != null && <footer className="mrd-section__footer">{footer}</footer>}
    </section>
  );
}
